import { NavLink } from 'react-router-dom';
import { Button } from '../ui/button';
import { LogOut, Leaf } from 'lucide-react';
import CurrencySelector from '../CurrencySelector';
import { SetPasswordDialog } from '../auth/SetPasswordDialog';

const UserAvatar = ({ user }) => {
  if (user?.picture) {
    return (
      <img
        src={user.picture}
        alt={user.name || user.username}
        className="w-10 h-10 rounded-full object-cover border-2 border-[#2E4632]"
      />
    );
  }
  return (
    <div className="w-10 h-10 rounded-full bg-[#2E4632] flex items-center justify-center text-white font-semibold">
      {(user?.name || user?.username || 'U')[0].toUpperCase()}
    </div>
  );
};

export const Sidebar = ({ navItems, user, onLogout }) => (
  <aside className="hidden md:flex md:flex-col md:w-64 md:fixed md:inset-y-0 bg-white border-r border-[#D1D1CD]">
    <div className="flex items-center gap-3 px-6 h-16 border-b border-[#D1D1CD]">
      <div className="w-10 h-10 bg-[#2E4632] rounded-full flex items-center justify-center">
        <Leaf className="w-5 h-5 text-white" />
      </div>
      <span
        className="text-xl font-bold text-[#2E4632]"
        style={{ fontFamily: 'Manrope, sans-serif' }}
      >
        FarmWorker
      </span>
      <span
        data-testid="beta-badge-sidebar"
        className="text-[10px] font-semibold tracking-wide text-[#2E4632] bg-[#2E4632]/10 border border-[#2E4632]/25 rounded-full px-2 py-0.5"
      >
        BETA
      </span>
    </div>

    <nav className="flex-1 px-4 py-6 space-y-1 overflow-y-auto">
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          data-testid={`nav-${item.label.toLowerCase()}`}
          className={({ isActive }) =>
            `flex items-center gap-3 px-4 py-3 rounded-lg font-medium transition-colors touch-target ${
              isActive
                ? 'bg-[#2E4632] text-white'
                : 'text-[#5C5C5C] hover:bg-[#E8E8E3] hover:text-[#2E4632]'
            }`
          }
        >
          <item.icon className="w-5 h-5" />
          {item.label}
        </NavLink>
      ))}
    </nav>

    <div className="p-4 border-t border-[#D1D1CD] space-y-3">
      <div className="flex items-center gap-3">
        <UserAvatar user={user} />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-[#1C1C1E] truncate">
            {user?.name || user?.username}
          </p>
          <p className="text-xs text-[#5C5C5C] truncate">
            {user?.email || 'Administrator'}
          </p>
        </div>
      </div>
      <div>
        <label className="text-xs font-medium text-[#5C5C5C] uppercase tracking-wide mb-1 block">
          Currency
        </label>
        <CurrencySelector compact />
      </div>
      {user?.has_password === false && <SetPasswordDialog />}
      <Button
        onClick={onLogout}
        data-testid="logout-btn"
        variant="outline"
        className="w-full h-10 border-[#BC4749] text-[#BC4749] hover:bg-[#BC4749]/10"
      >
        <LogOut className="w-4 h-4 mr-2" />
        Logout
      </Button>
    </div>
  </aside>
);
